import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
function getLocale(extension) {
    return extension.tags.find(t => t.startsWith('lp-'))?.split('lp-')[1];
}
const ILanguagePackService = ( createDecorator('languagePackService'));
export { ILanguagePackService, getLocale };
